export default "__VITE_ASSET__f027582a__"